import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UnitModel} from '../../../unit/unit.model';
import {ModalWindowService} from '../../../shared/modal-window/modal-window.service';
import {ModalWindowType} from '../../../shared/modal-window/modal-window-type';
import {TranslateService} from '@ngx-translate/core';
import {take} from 'rxjs/operators';
import {RouteLibraryEntities} from '../../../route/route-library-entity';
import {RouteLibraryService} from '../../../route/route-library.service';

@Component({
  selector: 'app-executor-unit-list-item',
  templateUrl: './executor-unit-list-item.component.html',
  styleUrls: ['./executor-unit-list-item.component.scss']
})
export class ExecutorUnitListItemComponent implements OnInit {
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  @Input() unit: UnitModel;
  @Output() deleteConfirmed = new EventEmitter<boolean>();
  constructor(
    private modalWindowService: ModalWindowService,
    private translate: TranslateService,
    protected routeLibrary: RouteLibraryService,
  ) { }

  ngOnInit() {
  }

  delete() {
    this.modalWindowService.showWindow({
      modalWindowType: ModalWindowType.Confirmation,
      text: this.translate.instant('`Are you sure you want to remove selected device from the courier`?')
    }).pipe(
      take(1)
    ).subscribe(result => {
      if (result.confirmed) {
        this.deleteConfirmed.emit(true);
      }
    });
  }

}
